import script from "./CartPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPage.vue?vue&type=script&setup=true&lang=js"

import "./CartPage.vue?vue&type=style&index=0&id=098bef1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098bef1d"]])

export default __exports__